export default __webpack_public_path__ + "static/sepoy-e759f7dd8a405e264cd7f7b43ee9c668.png";